import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import { auth } from './fireinit'
import VueMeta from 'vue-meta'
import i18n from '@/plugins/v-i18n'
import VueLazyload from 'vue-lazyload'
import filters from '@/filters'
// import VueProgressBar from 'vue-progressbar'

// ROUTER PROGRESS
// const options = {
//   color: '#3273dc',
//   failedColor: '#874b4b',
//   thickness: '3px',
//   // transition: {
//   //   speed: '0.2s',
//   //   opacity: '0.6s',
//   //   termination: 300
//   // },
//   // autoRevert: true,
//   location: 'top',
//   inverse: false
// }
// Vue.use(VueProgressBar, options)


import GoogleAnalytics from '@/plugins/GoogleAnalytics'
// ANALYTICS
Vue.use(GoogleAnalytics)


import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

import Buefy from 'buefy';
Vue.use(Buefy);

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


// import Field from 'buefy/dist/components/field'
// import Input from 'buefy/dist/components/input'
// import Autocomplete from 'buefy/dist/components/autocomplete'

// Vue.use(Field)
// Vue.use(Input)
// Vue.use(Autocomplete)

// Vue.use(VueLazyload)
// or with options
Vue.use(VueLazyload, {
  lazyComponent: true,
  preLoad: 1.5,
  // error: 'dist/error.png',
  // loading: 'dist/loading.gif',
  attempt: 1
})


Vue.config.productionTip = false

// https://vue-meta.nuxtjs.org/guide/metainfo.html
Vue.use(VueMeta, {
  tagIDKeyName: 'vmid',
  // optional pluginOptions
  refreshOnceOnNavigation: true
})


import "./assets/scss/main.scss";

auth.onAuthStateChanged(user => {
  // store.dispatch("fetchUser", user);
  // console.log('mainjs: CURENT USER', auth.currentUser);
  if (auth.currentUser) {
    store.dispatch("user/setUser", auth.currentUser)
  } else {
    // store.commit('ui/SET_LOADING', true, { root: true })
    store.dispatch('auth/signInAnonymously')
  }
});


// let app
// auth.onAuthStateChanged(() => {
// if (!app) {
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  created() { // necessary to set auth user on window refresh

    // if redirect from other domian route backButton to home
    if (document.referrer.split("/")[2] != location.hostname) {
      // console.log('REDIRECT');
      localStorage.setItem('firstVisit', 1)
    }
    // this.$store.dispatch('appData/fetchEventTypes')
  }

}).$mount('#app')
  // }

// })
